export const pathByBrandEnv = {
  atc: {
    prod: '//www.autotrader.com/pixall/pix-at.min.js',
    qa: '//test.autotrader.com/pixall/pix-at.min.js'
  },
  kbb: {
    prod: '//www.kbb.com/pixall/pix-kbb.min.js',
    qa: '//staging.kbb.com/pixall/pix-kbb.min.js'
  },
  ford: {
    prod: '//www.fordblueadvantage.com/pixall/pix-fba.min.js',
    qa: '//test.fordblueadvantage.com/pixall/pix-fba.min.js'
  },
  cad: {
    prod: '//pixall.caranddriver.com/pixall/pix-caranddriver.min.js',
    qa: '//pixall-np.caranddriver.com/pixall/pix-caranddriver.min.js'
  }
};
export default pathByBrandEnv;